import { z } from 'zod';

export function createPaginatedResultSchema<
  ItemType extends z.ZodTypeAny,
  KeyType extends z.ZodTypeAny,
>(itemSchema: ItemType, paginationKeySchema: KeyType) {
  return z.object({
    pagination: z.object({
      hasMore: z.boolean(),
      nextKey: paginationKeySchema.optional(),
      count: z.number(),
    }),
    data: z.array(itemSchema),
    debugInfo: z.record(z.string(), z.unknown()).nullable(),
  });
}
